// This file was automatically generated from render.medOrder.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.medOrder');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.medOrder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medOrder.prescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="rxUncontrolledOrderWrap">', (! opt_data.noRx) ? '<div class="fl"><span class="rxUncontrolledLabel">Rx' + ((opt_data.index) ? ' ' + soy.$$escapeHtml(opt_data.index) : '') + '</span></div>' : '', '<div class="rxUncontrolledOrder"><p class="emphasis">', (opt_data.type == 'Refill') ? 'Refill: ' : (opt_data.type == 'DoseChange') ? 'Change Order: ' : 'New Order: ', soy.$$escapeHtml(opt_data.displayedMedicationName), '</p>', (opt_data.signDate) ? '<p class="el8ItemDescription">Date of order: ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyMonthDay(soy.$$escapeHtml(opt_data.signDate)) : '') + ', ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyYear(soy.$$escapeHtml(opt_data.signDate)) : '') + '</p>' : '', (opt_data.directions) ? '<p class="el8ItemDescription">Sig: ' + soy.$$escapeHtml(opt_data.directions) + '</p>' : '');
  if (! opt_data.isSamples) {
    output.append('<p class="el8ItemDescription">Qty: ');
    el8.template.ptdata.model.medOrder.displayQuantity(soy.$$augmentData(opt_data, {wordy: true}), output);
    output.append('</p>', (! opt_data.concise) ? '<p class="el8ItemDescription">This dispense approved, plus an additional' + ((opt_data.authRefills) ? ' ' + soy.$$escapeHtml(opt_data.authRefills) : ' 0') + ' refill(s).</p>' : '');
  } else {
    output.append('<p class="el8ItemDescription">Qty: ');
    el8.template.ptdata.model.medOrder.displayQuantity(soy.$$augmentData(opt_data, {wordy: true}), output);
    output.append('</p>', (opt_data.numSamples) ? '<p class="el8ItemDescription">Samples: ' + soy.$$escapeHtml(opt_data.numSamples) + '</p>' : '');
  }
  output.append((opt_data.daysSupply) ? '<p class="el8ItemDescription">Days supply: ' + soy.$$escapeHtml(opt_data.daysSupply) + '</p>' : '<p class="el8ItemDescription">Days supply: Not specified</p>');
  if (opt_data.isAllowSubstitutions != null) {
    if (! opt_data.concise) {
      output.append('<p class="el8ItemDescription">');
      el8.template.ptdata.model.medOrder.substitutionsInstr(soy.$$augmentData(opt_data, {wordy: true}), output);
      output.append('</p>');
    }
  }
  output.append((opt_data.pharmacyInstructions) ? '<p class="el8ItemDescription">Instructions: ' + soy.$$escapeHtml(opt_data.pharmacyInstructions) + '</p>' : '');
  if (opt_data.icd10Codes && opt_data.icd10Codes.length) {
    output.append('<p class="el8ItemDescription">Dx (ICD-10): ');
    var icd10CodeList28879 = opt_data.icd10Codes;
    var icd10CodeListLen28879 = icd10CodeList28879.length;
    for (var icd10CodeIndex28879 = 0; icd10CodeIndex28879 < icd10CodeListLen28879; icd10CodeIndex28879++) {
      var icd10CodeData28879 = icd10CodeList28879[icd10CodeIndex28879];
      output.append((! (icd10CodeIndex28879 == 0)) ? ', ' : '', soy.$$escapeHtml(icd10CodeData28879));
    }
    output.append('</p>');
  }
  output.append((opt_data.isPostDated) ? '<p class="el8ItemDescription">Do not fill before: ' + soy.$$escapeHtml(opt_data.startDate) + '</p>' : '', (opt_data.deniedRefillRequest && opt_data.renewalReason) ? '<p class="el8ItemDescription">Reason for renewal: ' + soy.$$escapeHtml(opt_data.renewalReason) + '</p>' : '', (opt_data.deniedRefillRequest && opt_data.replaceReason) ? '<p class="el8ItemDescription">Reason for replacement: ' + soy.$$escapeHtml(opt_data.replaceReason) + '</p>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medOrder.signature = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p>', (opt_data.signUserBehalfName) ? 'Signed for: <span class="emphasis">' + soy.$$escapeHtml(opt_data.rxPrescriberName) + '</span> by ' + soy.$$escapeHtml(opt_data.signUserBehalfName) : 'By: <span class="emphasis">' + soy.$$escapeHtml(opt_data.rxPrescriberName) + '</span>', ' on ', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''), (opt_data.supervisingPhysicianName) ? '. Supervisor: ' + soy.$$escapeHtml(opt_data.supervisingPhysicianName) : '', '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medOrder.pharmacy = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pharmacyContactContainer"><p class="emphasis el8ItemDescription">', soy.$$escapeHtml(opt_data.name), (opt_data.canChange) ? ' <a class="change-pharmacy el8SmallTextLink">change pharmacy</a>' : '', '</p>', (opt_data.addressLine) ? '<p class="el8ItemDescription">' + soy.$$escapeHtml(opt_data.addressLine) + '</p>' : '', (opt_data.cityStateZip) ? '<p class="el8ItemDescription">' + soy.$$escapeHtml(opt_data.cityStateZip) + '</p>' : '', (opt_data.phone) ? '<p class="el8ItemDescription">Phone: ' + soy.$$escapeHtml(opt_data.phone) + '</p>' : '', (opt_data.fax) ? '<p class="el8ItemDescription">Fax: ' + soy.$$escapeHtml(opt_data.fax) + '</p>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medOrder.pharmacySmall = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p>', soy.$$escapeHtml(opt_data.name), ',', (opt_data.addressLine) ? ' ' + soy.$$escapeHtml(opt_data.addressLine) + ',' : '', (opt_data.cityStateZip) ? ' ' + soy.$$escapeHtml(opt_data.cityStateZip) + ',' : '', (opt_data.phone) ? ' Phone: ' + soy.$$escapeHtml(opt_data.phone) + ',' : '', (opt_data.fax) ? ' Fax: ' + soy.$$escapeHtml(opt_data.fax) : '', '</p>');
  if (!opt_sb) return output.toString();
};
